
import type { PropType } from 'vue'

import type {
    LngLatBounds, 
    YMap, 
    MapMode,
    DomEvent,
    DomEventHandlerObject,
} from '@yandex/ymaps3-types'

import { defineComponent } from 'vue'

import YandexMapProvider from './providers/YandexMap/index.vue'

export default defineComponent({
    components: {
        'yandex-map-provider': YandexMapProvider,
    },
    props: {
        provider: {
            type: String as PropType<'yandex'>,
            default: 'yandex'
        },
        providerScriptSrc: {
            type: String,
            required: true,
        },
        mapId: {
            type: String,
            default: 'yandex-map'
        },
        mode: {
            type: String as PropType<MapMode>,
            default: 'vector'
        },
        initialMapCenter: {
            default: () => [76.92523545812777, 43.25391893213578],
        },
        initialMapZoom: {
            type: Number as PropType<number>,
            default: 12,
        },
        restrictMapArea: {
            type: [Object, Boolean] as PropType<LngLatBounds | false>,
            default: false,
        },
    },
    emits: ['map-ready', 'map-destroyed', 'map-clicked'],
    setup(props, { emit }) {
        let map = null as YMap | null

        const onMapReady = (createdMap: YMap) => {
            map = createdMap
            emit('map-ready', map)
        }

        const onMapDestroyed = () => {
            map = null
            emit('map-destroyed')
        }

        const onMapClicked = (options: { object: DomEventHandlerObject; event: DomEvent }) => {
            emit('map-clicked', options)
        }

        return {
            onMapReady,
            onMapDestroyed,
            onMapClicked
        }
    }
})
